import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { QuoteModel } from 'src/app/models/quote.model';

@Component({
  selector: 'app-quick-quote-summary',
  templateUrl: './quick-quote-summary.component.html',
  styleUrls: ['./quick-quote-summary.component.scss'],
})
export class QuickQuoteSummaryComponent implements OnInit {

  @Input() quote: QuoteModel;
  @Input() quickQuote: QQQuestionnaireViewModel;
  @Input() page: string;
  @Output() back = new EventEmitter();
  @Output() continue = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  changeQuote() {
    if(this.page == 'summary-1')
      this.quickQuote.saveAnswer('CoverSource', null)
    this.back.emit();
  }
}
